import { MonochromeTheme } from "../.internal/themes/MonochromeTheme";
export default MonochromeTheme;
